import React, { useMemo } from 'react';

import { OOFlowWrapper } from '@features/oneOnboarding/wrappers/FlowWrapper';
import { apiQuery } from '@store/apiQuery';
import { store } from '@store/index';

import { useT } from '../../hooks/useT';
import { OOMultiSelectModelInterface } from '../../interfaces';

import { OOMultiSelect } from './OOMultiSelect';

export const OOMultiSelectComponent: React.FC<OOMultiSelectModelInterface> = (props) => {
  const { t, translationsLoading } = useT('entry');
  const flowData = store.getState().oneOnboarding.flow;
  const flowWrapper = useMemo(() => {
    if (!flowData) return null;
    return OOFlowWrapper.create(flowData);
  }, [flowData]);
  const isDisabled = flowWrapper?.isControlEditable(props.isEditableCandidate, props.isEditableRecruiter) ?? true;
  const { data, isFetching } = apiQuery.useGetMultiselectValuesQuery({
    name: props.controlHeaderName ? props.controlHeaderName : props.name.toLowerCase(),
  });

  return (
    <OOMultiSelect
      validationKey={props.name}
      label={t(props.label)}
      description={t(props.description)}
      data={data}
      mandatory={props.isMandatory}
      loading={translationsLoading || isFetching}
      defaultValue={props.defaultValue}
      onChangeCallback={props.onChangeCallback}
      itemModificationFunctions={props.itemModificationFunctions}
      disable={isDisabled}
    />
  );
};
